import React from 'react';

const DoDisturbIcon: React.FC<{ width?: string; height?: string; fill?: string }> = ({
  width = '18px',
  height = '18px',
  fill = '#2D2926',
}): React.ReactElement => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height={height}
        viewBox="0 0 24 24"
        width={width}>
        <g>
          <path d="M0,0h24v24H0V0z" />
        </g>
        <g>
          <g>
            <g>
              <path
                d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M4,12c0-4.4,3.6-8,8-8c1.8,0,3.5,0.6,4.9,1.7L5.7,16.9 C4.6,15.5,4,13.8,4,12z M12,20c-1.8,0-3.5-0.6-4.9-1.7L18.3,7.1C19.4,8.5,20,10.2,20,12C20,16.4,16.4,20,12,20z"
                fill={fill}
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default DoDisturbIcon;
